/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timeOfDay: NonNullable<unknown>, sport: NonNullable<unknown> }} Ui_Session_NameInputs */

const en_ui_session_name = /** @type {(inputs: Ui_Session_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.timeOfDay} ${i?.sport}`)
};

const de_ui_session_name = /** @type {(inputs: Ui_Session_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sport} ${i?.timeOfDay}`)
};

/**
* | output |
* | --- |
* | "{timeOfDay} {sport}" |
*
* @param {Ui_Session_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_session_name = /** @type {((inputs: Ui_Session_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Session_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_session_name(inputs)
	return de_ui_session_name(inputs)
});